"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientIdParameterDetail = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var ParameterDetail_1 = require("./ParameterDetail");
var react_intl_1 = require("react-intl");
var sdk_ui_1 = require("@gooddata/sdk-ui");
exports.ClientIdParameterDetail = function (_a) {
    var title = _a.title;
    var intl = react_intl_1.useIntl();
    var client = sdk_ui_1.useClientWorkspaceIdentifiers().client;
    return (react_1.default.createElement(ParameterDetail_1.ParameterDetail, { title: title, typeName: intl.formatMessage({
            id: "configurationPanel.drillIntoUrl.editor.identifierTypeLabel",
        }), useEllipsis: false, values: client ? [client] : [] }));
};
//# sourceMappingURL=ClientIdParameterDetail.js.map